import { createSchema } from '~/lib/useQueryParameter';
import { StaticProps } from '../../context/StaticPropsContext';
import { GradeConversionSearchQuery } from '../../context/QueryParameterContext';
import { pageNumberParameter } from './pageNumberParameter';
import { pageSizeParameter } from './pageSizeParameter';
import { sortParameter } from './sortParameter';

export type Parameters = {
  pageNumber: number;
  pageSize: number;
  sort: string;
};

// Minimal schema with no filters - just pagination and sort
export const schema = createSchema<StaticProps, GradeConversionSearchQuery, Parameters>({
  pageNumber: pageNumberParameter,
  pageSize: pageSizeParameter,
  sort: sortParameter,
});
